<template>
  <div class="hello">
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    msg: String
  },
  data() {
    return {
      p5Instance: null,
      hoveredElement: null,
      linkElements: [],
      mutationObserver: null
    }
  },
  methods: {
    setupHoverListeners() {
      // Set up explicit hover detection on all links
      const attachListenersToLink = (link) => {
        // Skip if already has listeners
        if (link.dataset.hasHoverListener) return;
        
        link.dataset.hasHoverListener = 'true';
        link.addEventListener('mouseenter', () => {
          this.hoveredElement = link;
        });
        link.addEventListener('mouseleave', () => {
          if (this.hoveredElement === link) {
            this.hoveredElement = null;
          }
        });
      };
      
      const attachAllListeners = () => {
        const links = document.querySelectorAll('a');
        links.forEach((link) => {
          attachListenersToLink(link);
        });
        this.linkElements = Array.from(links);
      };
      
      // Set up MutationObserver to catch dynamically added links
      this.mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              if (node.tagName === 'A') {
                attachListenersToLink(node);
              }
              // Check for nested links
              const nestedLinks = node.querySelectorAll?.('a');
              if (nestedLinks) {
                nestedLinks.forEach(attachListenersToLink);
              }
            }
          });
        });
      });
      
      this.mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Initial setup with delay to allow other components to mount
      setTimeout(attachAllListeners, 1000);
    },
    cleanupHoverListeners() {
      // Disconnect MutationObserver
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
      this.linkElements = [];
      this.hoveredElement = null;
    }
  },
  mounted() {   
    // Set up hover listeners after DOM is ready
    this.$nextTick(() => {
      this.setupHoverListeners();
    });
    
    const self = this; // Capture component context for p5 sketch
    const script = function (p5) {    


      function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
} 


      function findNearestElement(x, y) {
          let elements = document.querySelectorAll('a');
          let nearestPointInfo = null;
          let nearestElement = null;
          let nearestDistance = Infinity;
        

                        elements.forEach(element => {
                  let rect = element.getBoundingClientRect();
                  
                  // Points on the top and bottom edges
                  let horizontalPoints = [rect.left, rect.right].map(px => ({
                    x: px, y: clamp(y, rect.top, rect.bottom)
                  }));

                  // Points on the left and right edges
                  let verticalPoints = [rect.top, rect.bottom].map(py => ({
                    x: clamp(x, rect.left, rect.right), y: py
                  }));

                  // Combine all points
                  let points = [...horizontalPoints, ...verticalPoints];
                  points.forEach(point => {
                    let distance = p5.dist(x, y, point.x, point.y);
                    if (distance < nearestDistance) {
                      nearestDistance = distance;
                      nearestPointInfo = { element, distance, point };
                      nearestElement = element;
                    }
                  });
                });
                
          return {nearestElement, 
            x: nearestPointInfo.point.x,
            y: nearestPointInfo.point.y,
            distance: nearestDistance,
            width: nearestElement.getBoundingClientRect().width,
            height: nearestElement.getBoundingClientRect().height,
            x1: nearestElement.getBoundingClientRect().left,
            y1: nearestElement.getBoundingClientRect().top,
            x2: nearestElement.getBoundingClientRect().left + nearestElement.getBoundingClientRect().width,
            y2: nearestElement.getBoundingClientRect().top + nearestElement.getBoundingClientRect().height,
          };
        }

        
          var zoff = 10;
          var inc = 0.02;
          var rows;
          var cols;
          var scl = 15;
          var bg = '#000000';
          var mx = p5.mouseX;
          var my1 = p5.mouseY;
          var mx1 = p5.mouseX;
          var my = p5.mouseY;
          var mxAmoeba = p5.mouseX; // Lazy tracking for amoeba
          var myAmoeba = p5.mouseY;
          var lag = 40; // Negation area matches amoeba lag
          var lagMouse = 10;
          var lagAmoeba = 40; // Lazier tracking for amoeba
          let mouse_speed = 0;
          let mouseHistory = []; // Store mouse positions with frame numbers for ripples
          p5.setup = function () {
            p5.noiseSeed(1);
            p5.createCanvas(p5.windowWidth, p5.windowHeight);
            p5.background (bg);
            // p5.frameRate(14);

            cols = p5.floor(p5.width/scl);
            rows = p5.floor(p5.height/scl);
          }
          p5.windowResized = function () {
            p5.resizeCanvas(p5.windowWidth, p5.windowHeight);
          }
          p5.draw = function () {
            mouse_speed = p5.dist(p5.mouseX, p5.mouseY, mx1, my1);
            


            p5.fill(bg);
            p5.rect(0, 0, p5.width, p5.height);
            var yoff = 0;

            mx1 += (p5.mouseX-mx1)/lagMouse
            my1 += (p5.mouseY-my1)/lagMouse
            
            mxAmoeba += (p5.mouseX-mxAmoeba)/lagAmoeba
            myAmoeba += (p5.mouseY-myAmoeba)/lagAmoeba
                    
            mx += (p5.mouseX-mx)/lag
            my += (p5.mouseY-my)/lag
                    
            let nearestElement = findNearestElement(mx1, my1);
            

            let ttt = p5.frameCount * 0.05
            let breath = Math.sin(2*ttt +1.2*Math.sin(2*ttt) )

            let distance_from_mouse_nearest = nearestElement.distance
            let tt = 1- p5.min(1, p5.map(distance_from_mouse_nearest, 0, 200, 0, 1))
            
            // Check explicit hover state from event listeners
            let isExplicitlyHovering = self.hoveredElement !== null;
            
            // Store mouse position and hover state for ripple origin tracking
            mouseHistory.push({ frame: p5.frameCount, x: mxAmoeba, y: myAmoeba, tt: tt, hovering: isExplicitlyHovering });
            // Keep only recent history (more efficient: remove old entries in batch)
            if (mouseHistory.length > 550) {
              mouseHistory.splice(0, 50); // Remove 50 old entries at once instead of one at a time
            }
            
            // Amoeba pulse factor - only pulse when explicitly hovering
            let amoebaPulse;
            if (isExplicitlyHovering) {
              amoebaPulse = p5.map(breath, -1, 1, 0.85, 1.15); // Full pulsing when hovering
            } else {
              amoebaPulse = 1.0; // No pulse when not hovering
            }
            
            // Pre-compute ripple birth positions once per frame (performance optimization)
            let heartbeatPeriod = Math.PI * 20;
            let rippleBirthPositions = [];
            for (let i = 0; i < 5; i++) {
              let rippleBirthFrame = Math.floor(p5.frameCount / heartbeatPeriod) * heartbeatPeriod - (i * heartbeatPeriod);
              let birthPos = mouseHistory.find(h => h.frame === rippleBirthFrame);
              if (!birthPos && mouseHistory.length > 0) {
                birthPos = mouseHistory.reduce((closest, current) => {
                  return Math.abs(current.frame - rippleBirthFrame) < Math.abs(closest.frame - rippleBirthFrame) 
                    ? current : closest;
                });
              }
              rippleBirthPositions[i] = birthPos;
            }
            
            // Only affect animation speed when explicitly hovering, not by distance
            if (isExplicitlyHovering) {
              breath = breath*0.0001;
            } else {
              breath = 0; // No breath effect when not hovering
            }
            
              for (var y = 0; y < p5.height; y += scl){
                  var xoff = 0;
                  for (var x = 0; x < p5.width; x += scl){


                    // Apply amoeba distortion to negation area
                    let rawDistanceFromMouse = p5.dist(mx, my, x, y);
                    let angleToMouse = p5.atan2(y - my, x - mx);
                    let noiseScaleMouse = 0.005;
                    
                    // Distortion for negation area (similar to amoeba but independent noise)
                    let negationNoise1 = p5.noise(
                      p5.cos(angleToMouse) * 2.5 + mx * noiseScaleMouse, 
                      p5.sin(angleToMouse) * 2.5 + my * noiseScaleMouse, 
                      p5.frameCount * 0.0011
                    );
                    let negationNoise2 = p5.noise(
                      p5.cos(angleToMouse) * 3.5 + mx * noiseScaleMouse * 1.5, 
                      p5.sin(angleToMouse) * 3.5 + my * noiseScaleMouse * 1.5, 
                      p5.frameCount * 0.0014
                    );
                    let negationDistortion = p5.map(negationNoise1 * negationNoise2, 0, 1, 0.6, 2.2);
                    // Apply pulse factor to make negation area expand/contract with main amoeba
                    // When amoebaPulse is large (1.15), distance becomes larger, making negation area expand
                    let distance_from_mouse_pos = (rawDistanceFromMouse * negationDistortion) * amoebaPulse;
                    
                    // No content area restrictions - patterns can appear anywhere
                    let distance_from_content = Infinity; // Always pass content checks
                    let distance_from_content2 = Infinity;

                    // Horizontal gradient factor: increases from left (0.5) to right (1.5)
                    let horizontalFactor = p5.map(x, 0, p5.width, 0.5, 1.5);
                    // Inverse factor for distance thresholds (lower threshold = easier to trigger)
                    let thresholdFactor = p5.map(x, 0, p5.width, 1.2, 0.6);

                    let noisy_threshold =  p5.noise(xoff, yoff, p5.frameCount*.0005); 
                    var perlin = p5.noise(xoff, yoff, zoff) + 0.05*noisy_threshold;
                    
                    // Multi-layer amoeba: each layer forces perlin to specific range for different line patterns
                    let inAmoebaLayer = false;
                    let distFromMouseFast = p5.dist(mx1, my1, x, y); // Fast tracking for ripples
                    let distFromMouseAmoeba = p5.dist(mxAmoeba, myAmoeba, x, y); // Lazy tracking for amoeba
                    let pulsedRadius3 = 315 * amoebaPulse; // Declare outer radius for ripple access (30% smaller)
                    // Amoeba can appear anywhere, not just near elements
                    {
                      let angle = p5.atan2(y - myAmoeba, x - mxAmoeba);
                      let noiseScale = 0.005;
                      
                      // Layer 1: Inner core - force to 0.7 range (dense cross-hatch pattern)
                      let distortionNoise1a = p5.noise(
                        p5.cos(angle) * 2 + mx1 * noiseScale, 
                        p5.sin(angle) * 2 + my1 * noiseScale, 
                        p5.frameCount * 0.001
                      );
                      let distortionNoise1b = p5.noise(
                        p5.cos(angle) * 4 + mx1 * noiseScale * 2, 
                        p5.sin(angle) * 4 + my1 * noiseScale * 2, 
                        p5.frameCount * 0.0015
                      );
                      let distortion1 = p5.map(distortionNoise1a * distortionNoise1b, 0, 1, 0.5, 2.8);
                      let distortedDistance1 = distFromMouseFast * distortion1;
                      // Apply pulse to layer radius
                      let pulsedRadius1 = 84 * amoebaPulse; // 30% smaller
                      if (distortedDistance1 < pulsedRadius1) {
                        perlin = 0.7; // Force to 0.6-0.85 pattern range
                        inAmoebaLayer = true;
                      }
                      
                      // Layer 2: Middle ring - force to 0.57 range (single diagonal pattern)
                      else {
                        let distortionNoise2a = p5.noise(
                          p5.cos(angle) * 1.5 + mx1 * noiseScale * 0.8, 
                          p5.sin(angle) * 1.5 + my1 * noiseScale * 0.8, 
                          p5.frameCount * 0.0012
                        );
                        let distortionNoise2b = p5.noise(
                          p5.cos(angle) * 3 + mx1 * noiseScale * 1.5, 
                          p5.sin(angle) * 3 + my1 * noiseScale * 1.5, 
                          p5.frameCount * 0.0018
                        );
                        let distortion2 = p5.map(distortionNoise2a * distortionNoise2b, 0, 1, 0.5, 2.5);
                        let distortedDistance2 = distFromMouseFast * distortion2;
                        let pulsedRadius2 = 196 * amoebaPulse; // 30% smaller
                        if (distortedDistance2 < pulsedRadius2) {
                          perlin = 0.57; // Force to 0.55-0.6 pattern range
                          inAmoebaLayer = true;
                        }
                        
                        // Layer 3: Outer halo - force to 0.52 range (other diagonal pattern)
                        else {
                          let distortionNoise3a = p5.noise(
                            p5.cos(angle) * 1.2 + mx1 * noiseScale * 0.6, 
                            p5.sin(angle) * 1.2 + my1 * noiseScale * 0.6, 
                            p5.frameCount * 0.0008
                          );
                          let distortionNoise3b = p5.noise(
                            p5.cos(angle) * 2.5 + mx1 * noiseScale * 1.2, 
                            p5.sin(angle) * 2.5 + my1 * noiseScale * 1.2, 
                            p5.frameCount * 0.001
                          );
                          let distortion3 = p5.map(distortionNoise3a * distortionNoise3b, 0, 1, 0.5, 2.2);
                          let distortedDistance3 = distFromMouseFast * distortion3;
                          // pulsedRadius3 already declared above for ripple access
                          if (distortedDistance3 < pulsedRadius3) {
                            perlin = 0.52; // Force to 0.5-0.55 pattern range
                            inAmoebaLayer = true;
                          }
                        }
                      }
                      
                      // Ripple effect - created at max pulse, then expand independently
                      if (!inAmoebaLayer) {
                        // Max pulse radius (when amoeba is at maximum expansion)
                        let maxPulseRadius = 315 * 1.15; // 362.25px (30% smaller)
                        
                        // Create 5 ripples, each triggered by a different pulse peak
                        for (let i = 0; i < 5; i++) {
                          // Calculate when this ripple was born (at pulse peak)
                          let rippleBirthFrame = Math.floor(p5.frameCount / heartbeatPeriod) * heartbeatPeriod - (i * heartbeatPeriod);
                          
                          // Age in frames since birth
                          let rippleAgeFrames = p5.frameCount - rippleBirthFrame;
                          
                          // Ripple lifetime: 0 to 400 frames (~6.7 seconds at 60fps)
                          if (rippleAgeFrames > 0 && rippleAgeFrames < 400) {
                            // Use pre-computed birth position (no expensive lookup per pixel!)
                            let birthPos = rippleBirthPositions[i];
                            
                            // Only show ripple if it was born while explicitly hovering over an element
                            if (birthPos && birthPos.hovering) {
                              // Calculate distance from pixel to ripple origin (fixed at birth position)
                              let distFromRippleOrigin = p5.dist(birthPos.x, birthPos.y, x, y);
                              
                              // Start from max pulse radius, then expand at constant speed
                              let rippleRadius = maxPulseRadius + rippleAgeFrames * 2.5;
                              
                              // Ripple width grows linearly: start at 30px, grow 0.4px per frame (slower)
                              let rippleWidth = 30 + rippleAgeFrames * 0.4;
                              
                              // Check if this pixel is within the ripple
                              let distanceFromRipple = Math.abs(distFromRippleOrigin - rippleRadius);
                              if (distanceFromRipple < rippleWidth) {
                              // Smooth falloff at edges using cosine
                              let edgeFalloff = Math.cos((distanceFromRipple / rippleWidth) * Math.PI * 0.5);
                              // Fade out as ripple ages (0 to 1, then fade to 0)
                              let ageFalloff = 1 - (rippleAgeFrames / 400);
                              let rippleIntensity = 0.12 * edgeFalloff * ageFalloff;
                              perlin = perlin + rippleIntensity;
                              }
                            }
                          }
                        }
                      }
                    }
                    let color_intensity = p5.map(distance_from_mouse_pos * perlin, 0, 1500, 0, 255)
                    // color intensity in steps of 10
                    color_intensity = p5.round(color_intensity/20)*20
                    // Apply horizontal gradient to make right side more intense
                    color_intensity = color_intensity * horizontalFactor;
                    
                    // Add red component when near elements (exponential transition for more dramatic shift)
                    let ttExponential = Math.pow(tt, 2.5); // Exponential curve - changes slowly at first, rapidly near elements
                    let redAmount = p5.map(ttExponential, 0, 1, 0, 200); // 0 to 200 based on element proximity
                    let blueAmount = p5.map(ttExponential, 0, 1, 200, 100); // Decrease blue when closer
                    p5.stroke(120 + redAmount, 100, blueAmount, color_intensity);

                    // Apply threshold factor to make patterns more likely on the right
                    // Override conditions when in amoeba layer - allow patterns anywhere
                    let near_content3, near_content2, near_content, mouse_near, mouse_kinda_near, mouse_kinda_near2;
                    
                    if (inAmoebaLayer) {
                      near_content = true;
                      near_content2 = true;
                      near_content3 = true;
                      mouse_near = true;
                      mouse_kinda_near = true;
                      mouse_kinda_near2 = true;
                    } else {
                      near_content3 = (distance_from_content2 > 900*noisy_threshold*thresholdFactor) 
                      near_content2 = (distance_from_content2 > 800*noisy_threshold*thresholdFactor) 
                      near_content = (distance_from_content > 700*noisy_threshold*thresholdFactor) && near_content2
                      mouse_near = (distance_from_mouse_pos > 700*noisy_threshold*thresholdFactor) && near_content
                      mouse_kinda_near = (distance_from_mouse_pos > 500*noisy_threshold*thresholdFactor) && near_content
                      mouse_kinda_near2 = (distance_from_mouse_pos > 500*noisy_threshold*thresholdFactor) && near_content
                    }
                    
                    // Old red pulsing effect removed - replaced by ripples
                    
                    if (perlin > 0.5 && perlin < 0.55 && mouse_near) {
                      p5.line(x, y, x+scl, y+scl);
                    }else if (perlin >= 0.55 && perlin < 0.6 && mouse_kinda_near) {
                      p5.line(x, y+scl, x+scl, y);
                    } 
                    
                    if (perlin >= 0.6 && perlin < 0.85 && mouse_near) {
                       
                      if (near_content3) {
                        p5.line(x, y, x+scl, y+scl);
                      }

                      p5.line(x, y+scl, x+scl, y);
                    } else if (perlin >= 0.65 && mouse_kinda_near2) {
                      p5.line(x, y+scl, x+scl, y);
                    }

                    xoff += inc;
                  }

                  yoff += inc;
                  zoff += breath + 0.00000005*mouse_speed;
              }



            }







            }
            document.getElementById('defaultCanvas0')?.remove();
            const P5 = require('p5');
            this.p5Instance = new P5(script)
    },
  beforeUnmount() {
    // Clean up hover listeners
    this.cleanupHoverListeners();
    
    // Clean up p5 instance to prevent memory leaks
    if (this.p5Instance) {
      this.p5Instance.remove();
      this.p5Instance = null;
    }
    }
}
</script>

<style>
#defaultCanvas0{
  position:fixed;
  top:0;
  z-index: -10;
  pointer-events: none;
}
</style>
